// src/data/exercises/L6_02.js

const accountOptions = [
  '現金', '借入金', '備品', '貸付金', '未払金'];

export const L6_02 = {
  title: '簿記　3級（第215-2回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
       parts: [
    { "type": "ruby", "text": "石川株式会社", "ruby": "いしかわかぶしきがいしゃ" },
    { "type": "text", "value": "から、" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "￥3,000,000を" },
    { "type": "ruby", "text": "借", "ruby": "か" },
    { "type": "text", "value": "り" },
    { "type": "ruby", "text": "入", "ruby": "い" },
    { "type": "text", "value": "れ、" },
    { "type": "ruby", "text": "借用証書", "ruby": "しゃくようしょうしょ" },
    { "type": "text", "value": "を" },
    { "type": "ruby", "text": "引", "ruby": "ひ" },
    { "type": "text", "value": "き" },
    { "type": "ruby", "text": "渡", "ruby": "わた" },
    { "type": "text", "value": "した。" }
]
,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '現金', debitAmount: 3000000, creditAccount: '借入金', creditAmount: 3000000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '①現金￥3,000,000を借り入れ（借りる）\n' },
          { type: 'styled', value: '現金の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          { type: 'text', value: '借り入れ→借入金を使う\n' },
          { type: 'styled', value: '②借入金の増加（プラス）貸方（右・Ｃｒ）', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`

①現金￥3,000,000を借り入れ（借りる）
→現金の増加（プラス）します。

借り入れ→借入金を使う
②借入金の増加（プラス）します。


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '①現金￥3,000,000を借り入れ（借りる）\n' },
          { type: 'styled', value: '現金の増加（プラス）借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          { type: 'text', value: '借り入れ→借入金を使う\n' },
          { type: 'styled', value: '②借入金の増加（プラス）貸方（右・Ｃｒ）', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};